import moment from 'moment';
import styled from '@emotion/styled';

const Image = styled.img`
  max-height: 200px;
`;
export const condenseAnswers = (answers) => {
  let condensed = {};
  for (let key in answers) {
    if (typeof answers[key] === 'object' && !Array.isArray(answers[key])) {
      condensed = { ...condensed, ...answers[key] };
    } else {
      condensed[key] = answers[key];
    }
  }
  return condensed;
};

export const questionType = ({ text, type, textOnlyInQuestions }) => {
  if (textOnlyInQuestions) {
    return null;
  } else if (type === 'title') {
    return <h2>{text}</h2>;
  } else if (type === 'text') {
    return <p>{text}</p>;
  } else {
    return <h3>{text}</h3>;
  }
};

export const renderAnswers = (questions, answers) => {
  const condensedAnswers = condenseAnswers(answers);

  return questions?.flat()?.map((question) => {
    return (
      <div
        key={question.id}
        className={`${question.class || ''} ${
          !question.contentOnlyInQuestions && !question.textOnlyInQuestions ? 'question' : ''
        }`}
      >
        {questionType(question)}
        {!question.contentOnlyInQuestions &&
          formatAnswer(condensedAnswers?.[question.id], question?.type)}
      </div>
    );
  });
};

const formatAnswer = (content, type) => {
  if (type === 'date') {
    return (
      <p className="answer">
        {moment(content).isValid() ? moment(content).format('DD-MM-YYYY') : content}
      </p>
    );
  }
  if (type === 'photo') {
    return content ? (
      <Image src={content} alt="Foto del aspirante" />
    ) : (
      <p className="answer answer--empty">Sin foto</p>
    );
  }
  if (type === 'checkbox' && Array.isArray(content)) {
    return (
      <ul className="answer-list">
        {content.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
    );
  }
  if (typeof content === 'string' || typeof content === 'number' || typeof content === 'boolean') {
    return <p className="answer">{String(content)}</p>;
  }
  return <p className="answer">{content}</p>;
};

export const guestData = (guest) => (
  <div>
    <p className="userdata">
      <strong>
        {guest?.name} {guest?.lastName}
      </strong>
    </p>
    <p className="userdata">
      Teléfono: <strong>{guest?.phone}</strong>
    </p>
    {!!guest?.birthdate && (
      <p className="userdata">
        Edad: <strong>{moment().diff(guest?.birthdate, 'years')}</strong>
      </p>
    )}
    <p className="userdata">
      Genero: <strong>{guest?.gender}</strong>
    </p>
    <p className="userdata">
      Identificación: <strong>{guest?.identification}</strong>
    </p>
    <p className="userdata">
      Email: <strong>{guest?.email}</strong>
    </p>
  </div>
);
